import { render, staticRenderFns } from "./__SpecFeatureModal.vue?vue&type=template&id=2b5be744&"
import script from "./__SpecFeatureModal.vue?vue&type=script&lang=js&"
export * from "./__SpecFeatureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports